module.exports = __webpack_public_path__ + "static/media/01.93d773e1.png";